import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    ListItem,
    ListItemButton,
    Checkbox,
    ListItemText
} from '@mui/material';
import { ArrowBack as ArrowBackIcon, DoubleArrow as DoubleArrowIcon } from '@mui/icons-material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';


import { CONFIG } from "../../../../../../config";
const API_HOST_CRM = CONFIG.modules["crm"].host;

const SelectAgent = (
    {
        handleBack,
        cases,
        assignComplete
    }
) => {

    // redux
    const {
        roles,
        user,
        users,
        Designations,
        Departments,
        Languages,
        Districts,
        map,
    } = useSelector((state) => state.user || {});


    const [assigningSelected, setAssigningSelected] = useState(false);
    const [activeSelectedAssign, setActiveSelectedAssign] = useState(null);
    const [assignSelectedCompleted, setAssignSelectedCompleted] = useState(false);

    const [selectedAssign, setSelectedAssign] = useState(null);
    const [selectedAgents, setSelectedAgents] = useState({});

    return <Box
        sx={{
            // pointerEvents: "none",
            maxHeight: "500px",

            overflow: "auto",

        }}
    >
        <Box sx={{ mb: 1 }}>
            <Box
                sx={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => {
                    setSelectedAgents({});
                    handleBack();
                    // setActiveSelectedAssign(null);
                }}
            >
                <ArrowBackIcon sx={{ fontSize: "1.2em" }} /> &nbsp;Back
            </Box>
        </Box>
        <Box sx={{ pl: 2 }}>
            <Box
                sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{ fontWeight: "bold" }}>
                    Select Agents
                </Typography>
                <Box sx={{ display: "flex" }}>
                    {`selected (${Object.values(selectedAgents).length})`}
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setAssigningSelected(true);



                            axios
                                .post(API_HOST_CRM + "/allocate-selected-selected", {
                                    cases: cases.map((n) => n._id),
                                    agents: Object.values(selectedAgents).map(
                                        (a) => a._id
                                    ),
                                })
                                .then((resp) => {
                                    if (resp.data && resp.data.success) {
                                        setAssigningSelected(false);
                                        setAssignSelectedCompleted(true);
                                        toast.success("Assigned successfully");
                                        assignComplete()
                                    } else {
                                        setAssigningSelected(false);
                                    }
                                })
                                .catch((e) => {
                                    setAssigningSelected(false);
                                    console.log(e);
                                })
                                .finally(() => {
                                    setAssigningSelected(false);
                                });
                        }}
                        size="small"
                        sx={{ width: "max-content", ml: 1 }}
                    >
                        <DoubleArrowIcon sx={{ fontSize: "1.2em" }} /> &nbsp;
                        {assignSelectedCompleted
                            ? "Assign Completed"
                            : assigningSelected
                                ? "Assigning....."
                                : "Assign"}
                    </Button>
                </Box>
            </Box>
            {Array.isArray(users) &&
                users
                    .filter((u) =>
                        (u.roles || []).includes(process.env.REACT_APP_TELECALLER)
                    )
                    .map((u, i) => {
                        return (
                            <ListItem key={i} disablePadding>
                                <ListItemButton>
                                    <Checkbox
                                        checked={!!selectedAgents[u._id]}
                                        onChange={(e) => {
                                            let obj = { ...selectedAgents };
                                            if (e.target.checked) {
                                                obj[u._id] = u;
                                            } else {
                                                if (obj[u._id]) {
                                                    delete obj[u._id];
                                                }
                                            }
                                            setSelectedAgents(obj);
                                        }}
                                    />{" "}
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: ".8em" }}
                                        primary={`${u.name}`}
                                        onClick={() => {
                                            // addUserToShift(u._id);
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
        </Box>
    </Box >
}

export default SelectAgent;